export enum Queries {
    TRANSACTION_FIND_ALL = "transaction-find-all",
    USER_INFO = "user-info",
    PROGRAM_FIND_ALL = "program-find-all",
    POINTS_BALANCE_CONVERSION_RATE = "points-balance-conversion-rate",
    RANDOM_PARTNERS = "random-partners",
    PARTNERS_FIND_ALL_INFINITY = "partners-find-all-infinity",
    HELP_FIND_ALL = "help-find-all",
    ADDRESS_EXISTS = "address-exists",
    RESOLVE_ADDRESS = "resolve-address",
    GET_TOKEN = "get-token",
    GET_ORGANIZATION_INFO = "get-organization-info",
    POINT_CADUCITY = "point-caducity",
    GET_CITIES = "get-cities",
    GET_SENT_POINTS_RECEIPT="sent-points-receipt",
    GET_USER_ALERTS="get-user-alerts"
}
